import React from 'react'
import MultisiteSelector from '../SiteHeader/MultisiteSelector'

const SiteLogo = ({ siteHeaderData, isMobile=false, multisiteSelector, cinemasSorted, showMulticinemaSelectorMobile, cinemaSelectorLogo, cinemaData, hasCinemaSelector, className, theme, translation, currentCinemaId, toggleCinemaGroups }) => {
    const { homeURL, isFrontPage, siteName } = siteHeaderData

    return (
        isFrontPage ? (
            <h1 className="site-title site-logo">
                <a className='logo-image' href={homeURL} rel="home">
                    <span className="screen-reader-text">{siteName}</span>
                </a>
                {isMobile && cinemaData && cinemaSelectorLogo && hasCinemaSelector && showMulticinemaSelectorMobile && <MultisiteSelector
                    mobileClass={' mobile-selector'}
                    siteName={cinemaData.nameDisplay}
                    cinemasSorted={cinemasSorted}
                    cinemaSelectorLogo={cinemaSelectorLogo}
                    className={className}
                    multisiteSelector={multisiteSelector}
                    theme={theme}
                    translation={translation}
                    currentCinemaId={currentCinemaId}
                    toggleCinemaGroups={toggleCinemaGroups}
                />}
            </h1>
        ) : (
            <div className="site-title site-logo">
                <a className='logo-image' href={homeURL} rel="home">
                    <span className="screen-reader-text">{siteName}</span>
                </a>
                {isMobile && cinemaData && cinemaSelectorLogo && hasCinemaSelector && showMulticinemaSelectorMobile && <MultisiteSelector
                    mobileClass={' mobile-selector'}
                    cinemasSorted={cinemasSorted}
                    siteName={cinemaData.nameDisplay}
                    cinemaSelectorLogo={cinemaSelectorLogo}
                    className={className}
                    multisiteSelector={multisiteSelector}
                    theme={theme}
                    translation={translation}
                    currentCinemaId={currentCinemaId}
                    toggleCinemaGroups={toggleCinemaGroups}
                />}
            </div>
        )
    )
}

export default SiteLogo